import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { EduContentBookInterface, ProductInterface } from '@campus/dal';
import { DcrAnimatedKai } from '@diekeure/dcr-components';
import '@diekeure/dcr-components/dcr-animated-kai.js';

export interface BooksTileIconInterface {
  icon?: string;
  tooltip?: string;
  label?: string;
  className?: string;
}
export interface BooksTileBadgeInterface extends BooksTileIconInterface {
  label?: string;
  lottie?: string;
}
export interface BooksTileEventInterface {
  handler?: (id: number) => void;
  tooltip?: string;
}
export interface BooksTileActionInterface extends BooksTileEventInterface {
  icon?: BooksTileIconInterface;
}
export interface BooksTileLabelInterface extends BooksTileEventInterface {
  text: string;
}
export interface BooksTileRowInterface {
  guid?: number; // for trackBy
  label?: string;
  class?: string;
  icon?: BooksTileIconInterface;
  actions?: BooksTileActionInterface[];
  data: EduContentBookInterface; // the original data this row represents
  rowIcon?: BooksTileIconInterface;
}

export interface BooksTileComponentInterface {
  guid: number; // used for trackBy
  isAdaptive: boolean;
  adaptiveTaskEnabled?: boolean;
  hasFavorite?: boolean;
  badge?: BooksTileBadgeInterface;
  logoUrl?: string;
  title?: string;
  headerIcon?: BooksTileIconInterface;
  rows: BooksTileRowInterface[];
  data: ProductInterface; // the original data this tile represents
  selected: BooksTileRowInterface[];
}

@Component({
  standalone: false,
  selector: 'campus-books-tile',
  templateUrl: './books-tile.component.html',
  styleUrls: ['./books-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooksTileComponent {
  @ViewChild('kai', { static: false }) kai: ElementRef<DcrAnimatedKai>;

  @Input() data: ProductInterface; // original data this tile represents
  @Input() badge: BooksTileBadgeInterface;
  @Input() logoUrl: string;
  @Input() title: string;
  @Input() headerIcon: BooksTileIconInterface;
  @Input() rows: BooksTileRowInterface[] = [];
  @Input() disabled = false;

  @Output() rowClick = new EventEmitter<BooksTileRowInterface>();

  @HostBinding('class.shared-books-tile')
  sharedBooksTileClass = true;

  @HostListener('mouseenter', ['$event'])
  public onMouseEnter(event: MouseEvent): void {
    if (!this.disabled) {
      this.kai?.nativeElement?.setState('WAVING');
    }
  }

  @HostListener('mouseleave', ['$event'])
  public onLeave(event: MouseEvent): void {
    this.kai?.nativeElement?.setState('IDLE');
  }

  public trackByRowGuid(index: number, row: BooksTileRowInterface): number {
    return row.guid;
  }

  public onRowClick(row: BooksTileRowInterface): void {
    this.rowClick.emit(row);
  }
}
